<section id="answerSection" aria-labelledby="answers-section-title" class="pb-10 md:pb-36 home-answer-section">
  <div class="bg-[#ffffff] rounded-tl-[70px] rounded-tr-[70px] w-full h-[123px] "></div>
  <div class="custom-container">
    <div
      class="bg-[#f3f7f8] text-center md:h-[760px] h-[490px] rounded-[36px] md:p-20 sm:p-4 flex flex-col gap-2.5 items-center justify-start relative overflow-hidden">

      <div
        class="flex bg-[rgba(18,18,18,0.05)] rounded-[100px] md:mt-0 mt-8 md:mx-0 mx-8 pt-2 pr-4 pb-2.5 pl-4 flex-row gap-1.5 items-center justify-center">
        <span class="text-[rgba(18,18,18,0.50)] font-medium text-[16px]"
          [innerHTML]="'home.home_iphone_subtitle' | translate | safeHtml">
        </span>
      </div>

      <h2
        class="flex md:px-6 px-8 text-[#121212] font- font-[_sans-serif] text-[20px] sm:text-[20px] md:text-[50px] font-bold self-stretch items-center justify-center"
        id="answers-section-title" [innerHTML]="'home.home_iphone_title' | translate | safeHtml">
      </h2>

      <img src="/images/home/iphone.png"
        class="mb-0 pb-0 absolute bottom-0 md:w-[718px] sm:w-[343px] md:h-[435px] sm:h-[220px] pt-[40px]" />
    </div>
  </div>
</section>